import { clearTokenFromLocalStorage, registerAuthLifecycleHooks } from '@repo/auth-utils'
import { deleteSession, upgradeSessionFromToken } from '@repo/first-party-session'
import { invalidateToken } from '@repo/rpc-codegen/fetch-rpc'

async function upgradeSessionAndClearToken(token: string, origin: 'login' | 'registration') {
  // The RPC layer may hold an anonymous bearer for this page; from here on the
  // login identity rides on `fm_session`, so drop it before the upgrade.
  invalidateToken()
  await upgradeSessionFromToken(token, origin, { clearToken: clearTokenFromLocalStorage })
}

function forgetRpcTokenAndDeleteSession() {
  invalidateToken()
  deleteSession()
}

registerAuthLifecycleHooks({
  onTokenSaved: upgradeSessionAndClearToken,
  onLogOut: forgetRpcTokenAndDeleteSession,
})
